import { PortfolioId } from "@fartherfinance/frontend/api/Types";

export const modelIdIsNotNull = (
  modelId: PortfolioId | null
): modelId is PortfolioId => {
  return modelId !== null;
};
